<template>
	<div class="tw-flex tw-justify-center tw-items-center">
		<slot></slot>
		<v-menu
			content-class="report-menu-content"
			offset-y
			:nudge-bottom="5"
			:nudge-left="40"
			v-if="showReportMenu"
			:open-on-click="openOnClick">
			<v-btn
				flat
				icon
				slot="activator"
				class="btn-auto-list py-1 px-1 mr-3"
				@click="$emit('click-menu')">
				<img :src="img" alt="download" height="30">
			</v-btn>
			<v-list>
				<v-list-tile
					v-for="option in options"
					:key="option.id"
					@click="downloadDocument(option)"
					:disabled="disabledOption && option.id === 2">
					<v-list-tile-title>
						{{ option.name }}
					</v-list-tile-title>
				</v-list-tile>
			</v-list>
		</v-menu>
	</div>
</template>

<script>

	function downloadDocument(option) {
		if (this.showReportMenu) {
			if (this.disabledOption && option.id === 2) {
				return;
			}
			this.$emit('emit-report', option.code);
		}
	}

	export default {
		name: 'app-button-list',
		methods: {
			downloadDocument,
		},
		props: {
			openOnClick: {
				deafult: true,
				type: Boolean,
			},
			options: {
				default: () => [],
				type: Array,
			},
			img: {
				type: String,
				default: '',
			},
			showReportMenu: {
				default: false,
				type: Boolean,
			},
			disabledOption: {
				default: false,
				type: Boolean,
			},
		},
	};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/shared/app-button-list.vue